import { CommonModule } from '@angular/common';
import {Component, inject, OnInit} from '@angular/core';
import {ExamService} from "../../data-access/exam.service";
import {FontAwesomeModule} from "@fortawesome/angular-fontawesome";
import {faAdd, faChevronDown, faChevronUp, faMagnifyingGlass, faListCheck, faPencil} from "@fortawesome/free-solid-svg-icons";
import {DropdownMenuComponent, MenuItem} from "../../../shared/ui/dropdown-menu/dropdown-menu.component";
import {ActivatedRoute, Router} from "@angular/router";
import {OutlineButtonComponent} from "../../../shared/ui/outline-button/outline-button.component";
import {DropdownSearchComponent} from "../../../shared/ui/dropdown-search/dropdown-search.component";
import {MatSnackBar} from "@angular/material/snack-bar";
import {APIResponse} from "../../../shared/data-access/api-response.model";
import {FormsModule} from "@angular/forms";
import {MatIconModule} from "@angular/material/icon";
import {FullButtonComponent} from "../../../shared/ui/full-button/full-button.component";
import _ from "lodash";
import {BreadcrumbComponent, BreadcrumbNavigation} from "../../../shared/ui/breadcrumb/breadcrumb.component";

interface GraderResponse {
  exam_id: number,
  exam_uuid: string,
  student_username: string
  username: string,
  display_name: string,
  user_id: number,
  assigned_time: Date
  complete_by: Date
  // time might not be a date
  complete_time: Date
}
interface GraderItem {
  name: string
}
@Component({
    selector: 'exam-graders',
    templateUrl: './exam-graders.component.html',
    styleUrls: ['../list/list.component.css'],
    imports: [CommonModule, FontAwesomeModule, DropdownMenuComponent, OutlineButtonComponent, DropdownSearchComponent, FormsModule, MatIconModule, FullButtonComponent, BreadcrumbComponent]
})
export class ExamGradersComponent implements OnInit {
  constructor(private route: ActivatedRoute, private _snackBar: MatSnackBar) {}
  router = inject(Router)
  examService = inject(ExamService)
  faAdd = faAdd
  openAddGrader = false
  openConfirmDelete = false
  faChevronUp = faChevronUp
  faChevronDown = faChevronDown
  sortByName = false
  sortByDate = false
  graderResponse: GraderResponse[] = []
  examID = -1
  courseID = -1
  examGraderSearchText = ""
  graderToBeDeleted?: GraderResponse
  gradersToBeAdded: number[] = []
  gradersThatCanBeAdded: GraderResponse[] = []
  searchIconStyle = `color: ${localStorage.getItem('primaryColor')}; margin-right: 0.5rem; margin-left: 0.5rem; flex-shrink: 1;`
  graderSearchIsLoading = false
  breadcrumbNavs: BreadcrumbNavigation[] = [{
    text: 'Exam List',
    route: 'dashboard/exam/list'
  }]
  ngOnInit() {
    this.route.queryParams.subscribe(params => {
      if(params['exam_id']) {
        this.examID = params['exam_id']
        this.getGraders()
      }
      if(params['course_id']) {
        this.courseID = params['course_id']
      }
    })
  }

  getGraders() {
    this.examService.listGraders(this.examID).subscribe((response) => {
      if(response.success) {
        this.graderResponse = response.result
      } else {
        this._snackBar.open(response.msg, 'Dismiss', {panelClass: ['error-snackbar']})
      }
    })
  }

  examList() {
    this.router.navigate(['dashboard/exam/list'])
  }

  toggleNameSort() {
    this.sortByDate = false
    this.sortByName = !this.sortByName
    if(this.sortByName) {
      this.graderResponse.sort(function(a,b) {
        return a.username<b.username ? -1 : a.username>b.username ? 1: 0
      })
    } else {
      this.graderResponse.sort(function(a,b) {
        return a.username>b.username ? -1 : a.username<b.username ? 1: 0
      })
    }
  }

  toggleDateSort() {
    this.sortByName = false
    this.sortByDate = !this.sortByDate
    if(this.sortByName) {
      this.graderResponse.sort(function(a,b) {
        return a.assigned_time<b.assigned_time ? -1 : a.assigned_time>b.assigned_time ? 1: 0
      })
    } else {
      this.graderResponse.sort(function(a,b) {
        return a.assigned_time>b.assigned_time ? -1 : a.assigned_time<b.assigned_time ? 1: 0
      })
    }
  }

  openGraderDelete(iter: number) {
    this.openConfirmDelete = true
    this.graderToBeDeleted = this.graderResponse[iter]
  }

  cancelGraderDelete() {
    this.openConfirmDelete = false
    this.graderToBeDeleted = undefined
  }

  cancelGraderAdd() {
    this.openAddGrader = false
    this.examGraderSearchText = ""
    this.gradersToBeAdded = []
    this.gradersThatCanBeAdded = []
  }

  confirmGraderDelete() {
    if(this.examID !== -1 && this.graderToBeDeleted) {
      this.examService.removeGrader(this.examID, [this.graderToBeDeleted.user_id]).subscribe((response) => {
        if(response.success) {
          this._snackBar.open('Grader successfully deleted', 'Dismiss', {duration: 3000})
          this.getGraders()
        } else {
          this._snackBar.open(response.msg, 'Dismiss', {duration: 5000, panelClass: ['error-snackbar']})
        }
        this.cancelGraderDelete()
      })
    }
  }

  debounceSearch = _.debounce(() => {
    this.gradersThatCanBeAdded = []
    if(this.examGraderSearchText !== '') {
      this.graderSearchIsLoading = true
      this.examService.searchForExamGraders(this.courseID, this.examGraderSearchText).subscribe((response) => {
        if(response.success) {
          if(response.result.items.length > 5) {
            for(let i = 0; i<5; i++) {
              this.gradersThatCanBeAdded.push(response.result.items[i])
            }
          } else {
            this.gradersThatCanBeAdded = response.result.items
          }
        } else {

        }
        this.graderSearchIsLoading = false
      })
    }
  }, 200)

  addGrader(grader: GraderResponse) {
    if(this.examID !== -1) {
      this.examService.addGrader(this.examID, [grader.user_id]).subscribe((response) => {
        if(response.success) {
          this._snackBar.open('Grader Added', 'Dismiss', {duration: 3000})
          this.getGraders()
        } else {
         this._snackBar.open(response.msg, 'Dismiss', {duration: 5000, panelClass: ['error-snackbar']})
        }
        this.cancelGraderAdd()
      })
    }
  }

  protected readonly faMagnifyingGlass = faMagnifyingGlass;
}
